export default function DecorativeDivider({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-4 py-4 sm:py-5 ${className}`} data-testid="decorative-divider">
      <div className="h-px w-16 md:w-24" style={{ background: "linear-gradient(to right, transparent, #C4B298)" }} />
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10 2L12 8L18 10L12 12L10 18L8 12L2 10L8 8L10 2Z"
          fill="none"
          stroke="#C4B298"
          strokeWidth="0.8"
        />
      </svg>
      <div className="h-px w-16 md:w-24" style={{ background: "linear-gradient(to left, transparent, #C4B298)" }} />
    </div>
  );
}
